import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Button, Dialog, DialogTitle, DialogContent, IconButton, Container, DialogActions, styled, CircularProgress, FormControl, TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { checkMobileNumber, handleTypeNumber } from '../../utils/validation';

const AddCustomerModal = (props) => {
    const [errorMsg,setErrorMsg] = useState({
        customerName:false,
        mobile:false
    })

    const useStyles = makeStyles({
        root: {
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e9ecef",
                borderRadius: '30px',
                boxShadow: 'rgb(17 17 26 / 5%) 0px 1px 0px, rgb(17 17 26 / 10%) 0px 0px 8px'
            },
            "& .MuiOutlinedInput-adornedStart": {
                paddingLeft: '25px'
            },
            "& .MuiInputAdornment-positionStart": {
                marginRight: '18px'
            },
            "& .MuiOutlinedInput-adornedEnd": {
                paddingRight: '25px'
            },
            "& .MuiDialog-container": {
                alignItems: 'start',
                display: 'flex'
            }
        },
        paper: {
            "&  .MuiDialog-scrollPaper": {
                alignItems: 'start'
            }, width: 'calc(100% - 100px)'
        },
        select: {
            "&:focus": {
                backgroundColor: "white"
            }
        }
    });
    const classes = useStyles();
    const Input = styled('input')({
        display: 'none',
    });

    useEffect(() => {
        setErrorMsg({
            customerName:false,
            mobile:false
        });
    }, [props.show]);


     //function to check validations
     const checkFieldsValidation = (e) => {
        if (e.target.name === 'customerName') {
            if (!e.target.value)
                setErrorMsg({ ...errorMsg, [e.target.name]: `Customer name is required.` })
        }
        else if ((e.target.name === 'mobile')) {
            let msg = {...errorMsg};
            let result = checkMobileNumber(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
            setErrorMsg(msg)
            // return true
        }
    }

     //function to set specific field of error to null
     const handleError = (e) => {
        setErrorMsg({ ...errorMsg, [e.target.name]: false });
    }

    return <div className={styles.mainContainer}>
        <Dialog classes={{ paper: classes.paper, root: classes.root }} maxWidth="sm" open={props.show} onClose={() => props.handleClose()} >
            <DialogTitle id="customized-dialog-title" onClose={() => props.handleClose()} className={styles.modalTitle}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <div className="mb-0">Add Customer</div>
                    </div>
                    <div>
                        <IconButton className={styles.closeBtn} onClick={() => props.handleClose()}>
                            <CloseIcon className={styles.searchClose} />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className="mt-4 mb-4" >
                <Container maxWidth="md">
                    <FormControl variant="outlined" className="mb-2" fullWidth>
                        <TextField id="standard-basic" autoComplete="off" label="Enter Customer Name" name="customerName"  error={errorMsg.customerName ? true : false} helperText={errorMsg.customerName} value={props.addCustomerObj.customerName || ''} onChange={(e) => {props.handleCustomerInput(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                    </FormControl>
                    <FormControl variant="outlined" className="mb-2" fullWidth>
                        <TextField id="standard-basic" autoComplete="off" label="Enter Mobile Number" name="mobile"  
                         onKeyDown={(evt) => handleTypeNumber(evt)}
                        error={errorMsg.mobile ? true : false} helperText={errorMsg.mobile} value={props.addCustomerObj.mobile || ''} onChange={(e) => {props.handleCustomerInput(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                    </FormControl>
                </Container>
            </DialogContent>
            <DialogActions className="d-flex justify-content-end">
                <Button variant="contained" color="primary" disabled={errorMsg.mobile || errorMsg.customerName} onClick={() => !props.addUploadLoader && !errorMsg.mobile && !errorMsg.customerName ? props.addCustomerInfo() : null}>
                    Save
                    {props.addUploadLoader ? <CircularProgress className="ml-2" style={{ color: 'white' }} size={15} /> : null}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}

export default AddCustomerModal;